import _slicedToArray from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
var __jsx = React.createElement;
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import Loader from 'components/common/Loader';
import { useFetchScore } from 'libs/content/hooks/useFetchScore';
import { getFirstLoadContent } from 'redux/content';
import YTGOptimizationLevels from './YTGOptimizationLevels';
import { ScoreContainer, ScoreText, ScoreValue, YTGScoreContainer, YTGScoreHeader } from './YTGScoreField.style';

var getErrorMessage = function getErrorMessage(error, intl) {
  var _error$message$split = error.message.split(': '),
      _error$message$split2 = _slicedToArray(_error$message$split, 1),
      errorCode = _error$message$split2[0];

  switch (errorCode) {
    case '429':
      return intl.formatMessage({
        id: 'yourTextGuru.error.tooManyRequests'
      });

    case '556':
      return intl.formatMessage({
        id: 'yourTextGuru.error.calculatingNewGuide'
      }, {
        br: __jsx("br", null)
      });

    default:
      return intl.formatMessage({
        id: 'yourTextGuru.error.unsupported'
      });
  }
};

var YTGScoreField = function YTGScoreField(_ref) {
  var formField = _ref.formField;

  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var intl = useIntl();

  var _useSelector = useSelector(getFirstLoadContent),
      firstLoadContent = _useSelector.value,
      contentLoading = _useSelector.loading;

  var _useFetchScore = useFetchScore(),
      fetchScoreLoading = _useFetchScore.loading,
      doFetchScore = _useFetchScore.doFetchScore,
      score = _useFetchScore.score,
      danger = _useFetchScore.danger,
      error = _useFetchScore.error,
      optimizationLevels = _useFetchScore.optimizationLevels;

  useEffect(function () {
    if (!contentLoading && firstLoadContent !== undefined) {
      void doFetchScore(firstLoadContent, formField);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [contentLoading, formField]);
  useEffect(function () {
    if (error) {
      enqueueSnackbar(getErrorMessage(error, intl), {
        variant: 'error'
      });
    }
  }, [error, enqueueSnackbar, intl]);
  return __jsx(React.Fragment, null, fetchScoreLoading ? __jsx(Loader, null) : __jsx(React.Fragment, null, __jsx(YTGScoreContainer, null, __jsx(YTGScoreHeader, null, __jsx(ScoreContainer, null, __jsx(ScoreText, null, __jsx(FormattedMessage, {
    id: "yourTextGuru.scoreTitle"
  })), __jsx(ScoreValue, null, __jsx(FormattedMessage, {
    id: "yourTextGuru.scoreValue",
    values: {
      score: score
    }
  }))), __jsx(ScoreContainer, {
    isDanger: true
  }, __jsx(ScoreText, null, __jsx(FormattedMessage, {
    id: "yourTextGuru.dangerTitle"
  })), __jsx(ScoreValue, null, __jsx(FormattedMessage, {
    id: "yourTextGuru.scoreValue",
    values: {
      score: danger
    }
  })))), __jsx(YTGOptimizationLevels, {
    optimizationLevels: optimizationLevels
  }))));
};

export default YTGScoreField;